import React, { useEffect } from 'react';
import {
  Box, Container, Divider, LinearProgress,
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import Images from '../../../Configs/images';
import ROUTES from '../../../Configs/routes';
import { getUserDigitalBoxes } from '../../../Redux/Models/box';
import { getUserData } from '../../../Utils/storages';

export default function MyStorages({ classes }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = getUserData();
  const { isLoading, data } = useSelector((state) => state.box);

  useEffect(() => {
    dispatch(getUserDigitalBoxes(userData.id));
  }, []);

  const renderStorage = () => {
    if (isLoading) {
      return (
        <div className="mt-3">
          <LinearProgress color="inherit" />
        </div>
      );
    }
    if (data.length) {
      const box = data[0];
      return (
        <Box className="storage-card mt-3" onClick={() => navigate(`${ROUTES.myStorages()}/${box.id}`)}>
          <div className="flex space-between">
            <div className="s-14 weight-700">
              Aisle
              {' '}
              {box.column}
              {box.row}
            </div>
            <img src={Images.SafetyGuarantee} alt="safety guarantee" />
          </div>
          <div className="flex space-between mt-2">
            <div className="s-12 mute">{box.id}</div>
            <div className="s-12 mute">{moment(new Date(box.created_at)).format('HH.mm - DD/MM/YYYY')}</div>
          </div>
          <Divider sx={{ my: 2 }} />
          <div className="flex space-between mt-2">
            <div>
              <div className="s-12 mute">Category</div>
              <div className="s-14 weight-500 mt-1">Category</div>
            </div>
            <div>
              <div className="s-12 mute">Amounts</div>
              <div className="s-14 weight-500 mt-1">
                {box.items?.length}
                {' '}
                {box.items?.length > 1 ? 'Items' : 'Item'}
              </div>
            </div>
            <div>
              <div className="s-12 mute">Status</div>
              <div className="flex align-items-center gap-4 mt-1">
                <img src={Images.VerifiedIcon} alt="verified" />
                <div className="s-14 weight-500">Verified</div>
              </div>
            </div>
          </div>
          <div className="mt-25 flex gap-8">
            {box.photos?.map((photo) => (
              <img src={photo} key={photo} className="rounded cover" width="40" height="40" alt="item" />
            ))}
          </div>
        </Box>
      );
    }

    return (
      <Box className="center mt-4" sx={{ px: 2, pb: 1 }}>
        <img src={Images.EmptyBox} alt="Empty box" />
        <div className="mt-3 height-14">
          <div>There are no saved items in storage,</div>
          <div>
            click
            {' '}
            <strong>Request</strong>
            {' '}
            to start saving items
          </div>
        </div>
      </Box>

    );
  };
  return (
    <section className={classes.root}>
      <Container>
        <div>
          <Box>
            <div className="flex space-between align-items-center">
              <h4>
                My storages
              </h4>
              <Link to={ROUTES.myStorages()} className="link mute s-12 weight-500">View more</Link>
            </div>
          </Box>

          {renderStorage()}

        </div>
      </Container>
    </section>
  );
}
